import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Report.scss";
import { Reportmenupos } from "./Reportmenupos";
import { Daterangepos } from "../common/Daterangepos";
import TableModal from "../common/Modals/tableColumnPos";
import { _Api } from "../common/api/_call";
import DailySaleReportTableHead from "./DailySaleReportTableHead";
import { useReportColumnFilters } from "./useReportColumnFilters";
import { getNextSortConfig, sortTaxRegisterRows } from "./taxRegisterReportTableConfig";
import { useReportStickyColumns } from "./useReportStickyColumns";
import { postaxregisterreport_head } from "../../components/common/Tablehead";
import { useTranslation } from "react-i18next";
import { Pagination } from "../common/Pagination";
import TableLoader from "../../admin/common/TableLoader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Select from "react-select";

const TABLE_NAME = "report_taxregister_tbl";
const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const limitOptions = [
  { label: 100, value: 100 },
  { label: 200, value: 200 },
  { label: 300, value: 300 },
];

const TaxRegisterreport = () => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [newcolumndata, setnewcolumndata] = useState(postaxregisterreport_head);
  const [datefilter, setDatefilter] = useState([]);
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({});
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState("");
  const [loader, setLoader] = useState(false);
  const [sortConfig, setSortConfig] = useState({ columnIndex: null, direction: "asc" });
  const [state, setstate] = useState({ totalPages: 0, currentPage: 1 });
  const { totalPages, currentPage } = state;

  const activeTableColumns = newcolumndata?.length ? newcolumndata : postaxregisterreport_head;
  // the POS column modal stores status; hide those columns in header and body alike
  const headColumns = useMemo(
    () =>
      activeTableColumns.map((col) =>
        col?.status === false ? { ...col, class: `${col.class || ""} d-none` } : col
      ),
    [activeTableColumns]
  );
  const cellClass = (index, extra = "") =>
    [extra, activeTableColumns[index]?.status === false ? "d-none" : ""].filter(Boolean).join(" ");

  const columnFilters = useReportColumnFilters(rows, { user: "user" });
  const sortedRows = useMemo(() => sortTaxRegisterRows(columnFilters.rows, sortConfig), [columnFilters.rows, sortConfig]);

  const reportTableContainerRef = useRef(null);
  useReportStickyColumns(reportTableContainerRef, [sortedRows, activeTableColumns]);

  const callcolumns = async () => {
    try {
      const columnhead = await _Api({ name: TABLE_NAME }, `api/v1/Inventory/common/getColumnHeads`);
      if (columnhead.code === 200 && columnhead?.data?.data?.length) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    callcolumns();
  }, []);

  const getTaxRegister = async (current = 1, pageLimit = limit, search = filtername) => {
    setLoader(true);
    try {
      const postdata = {
        search: search || "",
        start_date: datefilter ? datefilter[0] : "",
        end_date: datefilter ? datefilter[1] : "",
        limit: pageLimit,
        skip: (current - 1) * pageLimit,
      };
      const res = await _Api(postdata, `api/v1/POS/report/taxRegister`);
      if (res?.code === 200) {
        setRows(res?.data || []);
        setTotals(res?.totals || {});
        setstate({
          totalPages: Math.ceil((Number(res?.count) || 0) / pageLimit),
          currentPage: current,
        });
      } else {
        setRows([]);
        setTotals({});
        setstate({ totalPages: 0, currentPage: 1 });
      }
    } catch (err) {
      console.log(err, "err");
    }
    setLoader(false);
  };

  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      getTaxRegister(1);
    }
    // eslint-disable-next-line
  }, [datefilter]);

  const filterbyname = (search) => getTaxRegister(1, limit, search);
  const changeLimit = (value) => {
    setLimit(value);
    getTaxRegister(1, value);
  };

  const downloadexclsheet = () => {
    const header = postaxregisterreport_head.map((col) => col?.lable);
    const body = sortedRows.map((row, key) => [
      (currentPage - 1) * limit + key + 1,
      row?.date,
      row?.doc_type,
      row?.ref,
      row?.description,
      row?.qty,
      row?.before_tax,
      row?.tax,
      row?.amount,
      row?.remark,
      row?.user,
    ]);
    const ws = XLSX.utils.aoa_to_sheet([["Tax Register"], header, ...body]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Records");
    const fileContent = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([fileContent], { type: fileType }), "tax_register_report");
  };

  const negativeClass = (value) => (String(value ?? "").startsWith("-") ? "danger-text" : "");

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0 w-100">
            <div className="catalog-area bg-white page-menu-block Dailysalereport">
              <div className="Dailysalereport-header">
                <div className="Dailysalereport-header-left">
                  <h3 className="common-navigation-header-left-heading Dailysalereport-head">
                    <Link to="" className="gray-mid text-decoration-none Dailysalereport-head-report">{t("REPORT")}</Link>
                    <img className="Dailysalereport-head-arrow mx-3" src={base_assets + "images/pos/report/arrow-right.png"} alt="" />
                    <span className="Dailysalereport-head-pagename">{t("Tax Register")}</span>
                  </h3>
                </div>
                <div className="Dailysalereport-header-reportdetail">
                  <div className="Dailysalereport-header-reportdetail-box">
                    <div className="Dailysalereport-header-reportdetail-box-inner">
                      <img className="Dailysalereport-header-reportdetail-box-inner-img" src={base_assets + "images/pos/report/stock-img.png"} alt="" />
                    </div>
                    <div className="Dailysalereport-header-reportdetail-box-text">
                      <span className="Dailysalereport-header-reportdetail-box-text-inner">{t("Before Tax")}</span>
                      <span className="Dailysalereport-header-reportdetail-box-text-data lightblue">{totals?.before_tax ?? 0}</span>
                    </div>
                  </div>
                  <div className="Dailysalereport-header-reportdetail-box">
                    <div className="Dailysalereport-header-reportdetail-box-inner">
                      <img className="Dailysalereport-header-reportdetail-box-inner-img" src={base_assets + "images/pos/report/value-img.png"} alt="" />
                    </div>
                    <div className="Dailysalereport-header-reportdetail-box-text">
                      <span className="Dailysalereport-header-reportdetail-box-text-inner">{t("Total Tax")}</span>
                      <span className="Dailysalereport-header-reportdetail-box-text-data maingreen">{totals?.tax ?? 0}</span>
                    </div>
                  </div>
                  <div className="Dailysalereport-header-reportdetail-box">
                    <div className="Dailysalereport-header-reportdetail-box-inner">
                      <img className="Dailysalereport-header-reportdetail-box-inner-img" src={base_assets + "images/pos/report/value-img.png"} alt="" />
                    </div>
                    <div className="Dailysalereport-header-reportdetail-box-text">
                      <span className="Dailysalereport-header-reportdetail-box-text-inner">{t("Total Amount")}</span>
                      <span className="Dailysalereport-header-reportdetail-box-text-data lightgray">{totals?.amount ?? 0}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="Dailysalereport-content-area">
                <div className="Dailysalereport-content-area-header">
                  <div className="Dailysalereport-content-area-header-inner">
                    <Reportmenupos Reportname={"Tax Register"} />
                    <Select
                      className="limit-select short mx-3"
                      options={limitOptions}
                      value={{ label: limit, value: limit }}
                      onChange={(e) => changeLimit(e.value)}
                    />
                    <div className="date"> <Daterangepos setDatefilter={setDatefilter} /></div>
                  </div>
                  <div className="catalog-area-header-area-control-right">
                    <div className="com-search-area">
                      <input
                        type="text"
                        value={filtername}
                        placeholder={t("Search by Ref")}
                        onKeyDown={(e) => e.key === "Enter" && filterbyname(e.target.value)}
                        onChange={(e) => setFiltername(e.target.value)}
                      />
                      {filtername ? <img className="com-search-area-clear" src={base_assets + "images/icons/False.png"} onClick={() => { setFiltername(""); filterbyname(""); }} alt="" /> : ""}
                      <img onClick={() => filterbyname(filtername)} className="com-search-area-img" src={base_assets + "images/pos/icons/magnifying-glass.png"} alt="" />
                    </div>
                    <div className="dropdown Dailysalereport-content-area-header-leftdropdown">
                      <button className="btn-style" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><img src={base_assets + "images/icons/ellipsis-circular.png"} alt="" /></button>
                      <ul className="dropdown-menu Dailysalereport-content-area-header-leftdropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li onClick={downloadexclsheet}>
                          <Link className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" to="#">
                            <div className="dropdown-menu-img">
                              <img src={base_assets + "images/pos/report/export-icon.png"} alt="" />
                            </div>
                            {t("Export")}</Link>
                        </li>
                        <li data-bs-toggle="modal" data-bs-target="#columnModal">
                          <Link className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" to="#">
                            <div className="dropdown-menu-img">
                              <img src={base_assets + "images/icons/column-icon.png"} alt="" />
                            </div>
                            {t("Column")}</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="Dailysalereport-content-area-main" ref={reportTableContainerRef}>
                  <div className="main-body-main-table-wrap Dailysalereport-table position-relative" id="table-scroll">
                    <table id="tax_register_report" className="common-table first-row-gray w-100 Dailysalereport-table-main daily-sale-report-table">
                      <DailySaleReportTableHead
                        tablehead={headColumns}
                        sortConfig={sortConfig}
                        onSort={(index, direction) => setSortConfig((current) => getNextSortConfig(current, index, direction))}
                        columnFilters={columnFilters}
                      />
                      <tbody>
                        {/* hide the previous rows while loading so the loader under the header is visible */}
                        {!loader && sortedRows.map((row, key) => {
                          const red = row?.is_negative ? "danger-text" : "";
                          return (
                            <tr key={row?.order_id || key}>
                              <td className={cellClass(0)}>{(currentPage - 1) * limit + key + 1}</td>
                              <td className={cellClass(1)}>{row?.date || ""}</td>
                              <td className={cellClass(2, "link-color")}>{row?.doc_type || ""}</td>
                              <td className={cellClass(3, "link-color")}>{row?.ref || ""}</td>
                              <td className={cellClass(4)}>{row?.description || ""}</td>
                              <td className={cellClass(5, red)}>{row?.qty ?? 0}</td>
                              <td className={cellClass(6, red)}>{row?.before_tax_formatted ?? 0}</td>
                              <td className={cellClass(7, red)}>{row?.tax_formatted ?? 0}</td>
                              <td className={cellClass(8, red)}>{row?.amount_formatted ?? 0}</td>
                              <td className={cellClass(9)}>{row?.remark || ""}</td>
                              <td className={cellClass(10)}>{row?.user || ""}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td className={cellClass(0)}></td>
                          <td className={cellClass(1)}></td>
                          <td className={cellClass(2)}></td>
                          <td className={cellClass(3)}></td>
                          <td className={cellClass(4)}></td>
                          <td className={cellClass(5, negativeClass(totals?.qty))}>{totals?.qty ?? 0}</td>
                          <td className={cellClass(6, negativeClass(totals?.before_tax))}>{totals?.before_tax ?? 0}</td>
                          <td className={cellClass(7, negativeClass(totals?.tax))}>{totals?.tax ?? 0}</td>
                          <td className={cellClass(8, negativeClass(totals?.amount))}>{totals?.amount ?? 0}</td>
                          <td className={cellClass(9)}></td>
                          <td className={cellClass(10)}></td>
                        </tr>
                      </tfoot>
                    </table>
                    {loader && <TableLoader />}
                  </div>
                </div>
                {rows.length > 0 ? (
                  <Pagination
                    total={totalPages}
                    current={currentPage}
                    pagination={(crPage) => getTaxRegister(crPage)}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <TableModal tablehead={postaxregisterreport_head} tblName={TABLE_NAME} setnewcolumndata={setnewcolumndata} />
      </div>
    </>
  );
};
export default TaxRegisterreport;
